import OwnersPropertiesMachine from 'features/OwnersProperties/view/machine/OwnersPropertiesMachine'
import { ErrorLib } from 'libs/errors'
import { XStateLib } from 'libs/XStateLib'

const OwnersPropertiesMachineContext = XStateLib.createRuntimeActorContext(
  OwnersPropertiesMachine.make().pipe(ErrorLib.tapCauseReporter),
)

export default OwnersPropertiesMachineContext
